import { InjectionToken } from '@angular/core';

export const pageUrlConstants = {
  ROOT: '/',
  HOME_RSX: '/home',
  HOME:
    // redirect
    // Auth
    '/?redirectPath&redirectUrl&message&success',

  // locations
  LOCATIONS: '/locations',
  LOCATIONS_CITIES: 'locations/:state',
  LOCATIONS_CITIES_RSX: ':state',
  LOCATIONS_LOCAL_DUMPSTER:
    '^/{locations:[^/]+}/{state:[^/]+}/{path:.+-dumpster-rental$}',
  LOCATIONS_LOCAL_LANDING:
    '^/{locations:[^/]+}/{state:[^/]+}/{path:.+-(?:trash-pickup-and-recycling|commercial-trash-and-recycling)$}',
  LOCATIONS_POSTAL_CODES: '^/locations/:state/:city',
  LOCATIONS_POSTAL_CODES_RSX: 'locations/:state/:city',
  LOCATIONS_CONTENT: ':state/:city/:postalCode',

  // Auth
  LOGIN: '/account/login?redirectUrl&redirectPath',
  LOGIN_RSX: '/account/login',
  LOGIN_POPUP: 'login-popup',
  LOGOUT_URL: 'account/logout',
  LOGOUT_RSX: '/account/logout',
  PASSWORD_RESET: 'password-reset',
  SIGNUP: '/account/signup',
  REFRESH: '^/account/refresh?redirectUrl',
  REFRESH_URL: 'account/refresh',
  RESET: '/account/reset',
  VERIFY_EMAIL: '/profile/verify-email',
  VERIFY_EMAIL_URL: 'profile/verify-email',
  VERIFY_PROFILE_INFO_RSX: '/verify-profile-info',
  VERIFY_PROFILE_INFO_URL: 'verify-profile-info',

  PRIVACY_POLICY_RSX: '/privacy',
  TERMS_OF_USE_RSX: '/terms-of-use',

  // MR Admin
  MR_ADMIN: 'admin',
  MR_ADMIN_USER_SEARCH: 'user-search',

  // My Resource
  MR_ALERTS: '^/account/alerts',
  MR_ALERTS_URL: 'account/alerts',
  MR_DASHBOARD: '^/account/dashboard?rateMyService',
  MR_DASHBOARD_RSX: '/account/dashboard',
  MR_DASHBOARD_URL: 'account/dashboard',
  MR_LINK_ACCOUNT: 'account/link',
  MR_OUTAGE: 'account/outage',
  MR_PAYMENTS_DASHBOARD: '^/account/payment',
  MR_PAYMENTS_DASHBOARD_URL: 'account/payment',
  MR_PAYMENTS_PAY_BILL: '^/account/payment/pay-bill',
  MR_PAYMENTS_PAY_BILL_RSX: 'pay-bill',
  MR_PAYMENTS_PAY_BILL_URL: 'account/payment/pay-bill',
  MR_PAYMENTS_PAY_BILL_SUCCESS: '^/account/payment/pay-bill/thank-you',
  MR_PAYMENTS_PAY_BILL_SUCCESS_RSX: 'pay-bill/thank-you',
  MR_PAYMENTS_PAY_BILL_SUCCESS_URL: '/account/payment/pay-bill/thank-you',

  // My Resource - Manage Account
  MR_MANAGE_ACCOUNT_URL: 'account/manage',
  MR_ACCOUNT_INFORMATION: 'account-info',
  MR_ACCOUNT_INFORMATION_URL: '/account/manage/account-info',
  MR_SERVICE_LOCATIONS: 'service-locations',
  MR_SERVICE_LOCATIONS_URL: '/account/manage/service-locations',
  MR_USERS: 'users',
  MR_USERS_URL: '/account/manage/users',
  MR_PAYMENT_METHODS: 'payment-methods',
  MR_PAYMENT_METHODS_URL: '/account/manage/payment-methods',
  MR_AUTO_PAY: 'auto-pay',
  MR_AUTO_PAY_URL: '/account/manage/auto-pay',
  MR_PAPERLESS: 'paperless',
  MR_PAPERLESS_URL: '/account/manage/paperless',

  // My Resource - User Profile
  MR_USER_PROFILE_URL: 'account/profile',
  MR_CONTACT_INFORMATION: 'contact-information',
  MR_CONTACT_INFORMATION_URL: '/account/profile/contact-information',
  MR_COMMUNICATION_PREFERENCES: '/communication-preferences',
  MR_CHANGE_PASSWORD: 'change-password',
  MR_CHANGE_PASSWORD_URL: '/account/profile/change-password',

  // My Resource - Services
  MR_SERVICES: 'account/services',
  MR_SERVICES_SCHEDULE_PICKUP: 'account/services/schedule-pickup',
  MR_SERVICES_SCHEDULE_PICKUP_RSX: 'schedule-pickup',
  MR_SERVICES_MISSED_PICKUP: 'account/services/missed-pickup',
  MR_SERVICES_MISSED_PICKUP_RSX: 'missed-pickup',
  MR_SERVICES_REPAIR_REPLACE: 'account/services/repair-replace',
  MR_SERVICES_REPAIR_REPLACE_RSX: 'repair-replace',
  MR_SERVICES_SEASONAL_STOP_START: 'account/services/seasonal-stop-start',
  MR_SERVICES_GATE_LOCK_ACCESS: 'account/services/gate-lock-access',
  MR_SERVICES_GATE_LOCK_ACCESS_RSX: 'gate-lock-access',
  MR_SERVICES_SEASONAL_STOP_START_RSX: 'seasonal-stop-start',
  MR_SERVICES_RELOCATE_CONTAINER: 'account/services/relocate-container',
  MR_SERVICES_RELOCATE_CONTAINER_RSX: 'relocate-container',
  MR_SERVICES_CONFIRMATION: 'account/services/confirmation',
  MR_SERVICES_CONFIRMATION_RSX: 'confirmation',
  ONE_TIME_PAYMENT: 'one-time-payment',

  // My Resource - Track My Truck History
  TRACK_MY_TRUCK_HISTORY: 'account/tmthistory',

  // Preference Center
  PREFERENCE_CENTER: 'preferences',

  NOTIFICATIONS: 'notifications',
  TMT_NOTIFICATION: 'tmt-notifications',
  USER_NOTIFICATION: 'account/notifications',

  // search
  SEARCH: '/search/:searchQuery',

  // shop
  SHOP: '/shop',
  SHOP_CART_RSX: '/shop/cart',
  SHOP_CATEGORIES_RSX: '/shop/categories',
  SHOP_CHECKOUT_RSX: '/shop/checkout',
  SHOP_CONFIGURE_RSX: '/shop/configure',
  SHOP_CONFIRM_ORDER: '/shop/confirm-order',
  SHOP_CONTACT_US_THANK_YOU_RSX: '/shop/contact-us/thank-you',
  SHOP_CONTACT_US_RSX: '/shop/contact-us',
  SHOP_ORDER_DETAILS: '/shop/order-details',
  SHOP_ORDER_DETAILS_HASH: '/shop/order-details/:hash',
  SHOP_SIGNUP_RSX: '/shop/signup',
  SHOP_ORDER_REVIEW_RSX: '/shop/order-review',
  DUMPSTER_RESIDENTS: '/residents/dumpster-rental',
  DUMPSTER_BUSINESSES: '/businesses/dumpster-rental',

  // utility navigation
  CUSTOMER_SUPPORT: '/customer-support',
  SCHEDULE: '/schedule',

  // misc pages
  CUSTOMER_SUPPORT_CONTACT_US: '/customer-support/contact-us',
  CUSTOMER_SUPPORT_CONTACT_US_RSX: 'customer-support/contact-us',
  SCHEDULE_REQUEST_REPORT_PROPERTY_ISSUE:
    '/account/services/report-property-issue',
  SCHEDULE_REQUEST_REPORT_PROPERTY_ISSUE_RSX: 'report-property-issue',

  // error urls
  ERROR404URL: '404',
  ERROR500URL: 'error',

  // blog
  BLOG: '/blog/*blogPath?rsid',

  // cms routing
  CMS: '/*path',
  CITYOFLAURL: 'https://www.lacitysan.org/',

  // Service alerts
  SERVICE_ALERTS: '/service-alerts',
  AREA_SERVICE_ALERTS: '/uitest/area-service-alerts',

  // Other services
  RESIDENTS_BULK_WASTE: '/residents/bulk-waste',
  RESIDENTS_DUMPSTER_RENTAL: '/residents/dumpster-rental',
  RESIDENTS_RECYCLING: '/residents/recycling',
  RESIDENTS_RECYCLING_E_WASTE: '/residents/recycling/e-waste',

  BUSINESSES_BULK_WASTE: '/businesses/bulk-waste',
  BUSINESSES_DUMPSTER_RENTAL: '/businesses/dumpster-rental',
  BUSINESSES_RECYCLING: '/businesses/recycling',
  BUSINESSES_RECYCLING_E_WASTE: '/businesses/recycling/e-waste',
  BUSINESSES_RECYCLING_LIGHT_BULB: '/businesses/recycling/light-bulb',
  TRACK_MY_TRUCK_RSX: 'track-my-truck',
  TRACK_MY_TRUCK_URL: '/track-my-truck',
};

export type PageUrlConstants = typeof pageUrlConstants;

export const pageUrlConstantsToken = new InjectionToken<PageUrlConstants>(
  'pageUrlConstantsToken'
);
